import { List as ProjectsList } from './List';

export default ProjectsList;
